import * as React from 'react';
import { Component } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import styles from '../../styles/forms/edit_linked_specification_wizard/EditLinkedSpecificationForm.scss';
import Button from '../../components/Button';
import { __, mapStateToProps, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import Select from '../../components/Select';
import * as _ from 'lodash';

@withRouter
@subscribe(Localization, 'localization')
@reduxForm({
  form: 'edit_product_file_category_wizard.edit_product_file_category',
})
@mapStateToProps((state) => ({
  store: _.get(state.table, 'products'),
}))
class EditProductFileCategoryForm extends Component {
  render() {
    const categories = [
      {
        label: __('working-set-specifications.images.thumbnail'),
        value: 'thumbnail',
      },
      {
        label: __('working-set-specifications.product'),
        value: 'product',
      },
      {
        label: __('working-set-specifications.drawing'),
        value: 'drawing',
      },
      {
        label: __('working-set-specifications.ambient'),
        value: 'ambient',
      },
      {
        label: __('working-set-specifications.technical'),
        value: 'technical',
      },
      {
        label: __('working-set-specifications.tileable-texture-for-3d'),
        value: 'tileable',
      },
      {
        label: __('working-set-specifications.files.manuals'),
        value: 'manuals',
      },
      {
        label: __('working-set-specifications.files.datasheets'),
        value: 'datasheets',
      },
      {
        label: __('working-set-specifications.files.guarantee'),
        value: 'guarantee',
      },
      {
        label: __('working-set-specifications.files.certificates'),
        value: 'certificates',
      },
      {
        label: __('working-set-specifications.files.catalogs'),
        value: 'catalogs',
      },
      {
        label: __('working-set-specifications.files.installation'),
        value: 'installation',
      },
      {
        label: __('working-set-specifications.files.bim'),
        value: 'bim',
      },
      {
        label: __('working-set-specifications.files.3d'),
        value: '3d',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.cad'),
        value: 'cad',
      },
      {
        label: __('working-set-specifications.files.2d'),
        value: '2d',
      },
      {
        label: __('working-set-specifications.files.light-data'),
        value: 'light_data',
      },
      {
        label: __('working-set-specifications.files.video'),
        value: 'video',
      },
      {
        label: __('working-set-specifications.files.audio'),
        value: 'audio',
      },
      {
        label: __('working-set-specifications.files.other'),
        value: 'other',
      },
    ];

    const {
      store: { file_ext },
    } = this.props;

    return (
      <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
        <div className={styles.form}>
          <Field
            name='category'
            component={Select}
            searchable
            label={__('products.flyout.edit-product-file-category')}
            options={
              !_.includes(['jpg', 'jpeg', 'png'], _.toLower(file_ext))
                ? _.filter(
                    categories,
                    (category) =>
                      !_.includes(
                        [
                          'thumbnail',
                          'product',
                          'drawing',
                          'ambient',
                          'technical',
                          'tileable',
                        ],
                        category.value
                      )
                  )
                : categories
            }
          />
        </div>
        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={() =>
              setTableParams('products', {
                edit_product_file_category: undefined,
              })
            }
          />
          <Button
            lightBlue
            medium
            right
            submit
            middleText={__('button.edit')}
            spinning={this.props.submitting}
          />
        </div>
      </Form>
    );
  }
}

export default EditProductFileCategoryForm;
